module.exports = __webpack_public_path__ + "img/puzzle9_b2.d1c87286.png";